import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import SmallSlides from './smallSlides';
import ScrollText from './scrollText';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

const TumourSpeak = ({ content }) => {
    return (
        <div className={styles.column}>
            <div
                className={styles.tumourShotTh}
                style={{ backgroundImage: `url(${content.mouldeBigImage})` }}
            >
                {content.title}
            </div>
            <div className={styles.tumourShotBd}>
                <Chip
                    id="285829"
                    type="recommend"
                    title="小幻灯"
                    groupName="预防肿瘤"
                    content={content.smallSildesData}
                >
                    <SmallSlides />
                </Chip>
                <Chip
                    id="285830"
                    type="recommend"
                    title="对肿瘤说NO"
                    groupName="预防肿瘤"
                    content={content.tumourSpeakData}
                >
                    <ScrollText />
                </Chip>
            </div>
        </div>
    );
};

TumourSpeak.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(TumourSpeak);
